<template>
  <v-dialog
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    :value="true"
    width="750"
  >
    <!--BARRA AZUL  -->
    <v-toolbar color="primary" dark flat class="cvi-dialog-toolbar">
      <v-toolbar-title class="d-flex flex-column justify-center">
        <span class="text-h6" v-text="inscricao.matricula.pessoa.nome" />

        <span
          class="text-caption"
          v-text="
            `Matrícula: ${inscricao.matricula.codigo}  ${' - ' +
              inscricao.matricula.etapa.nome} | ${
              inscricao.matricula.unidadeEnsino.nomeCompleto
            }`
          "
        />
      </v-toolbar-title>
      <!--BARRA AZUL FIM-->
      <v-spacer />

      <v-btn icon @click="$emit('close')">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-card color="grey lighten-5" :loading="loading">
      <template slot="progress">
        <v-progress-linear color="primary" height="5" indeterminate />
      </template>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-h6 pt-5 pb-0"
            v-text="`Protocolo: ${inscricao.protocolo}`"
          />

          <v-col
            cols="12"
            class="text-caption pt-0"
            v-text="
              `Data da Inscrição: ${format(
                parseISO(inscricao.data_cadastro),
                'dd/MM/yyyy',
              )}`
            "
          />

          <v-col cols="12" class="text-overline mt-n5">
            <span
              >Deficiência:
              {{ inscricao.particularidades ? "Sim" : "Não" }}</span
            >
            <br />
            <span>
              Vulnerabilidade Social:
              {{ inscricao.vulnerabilidade_social ? "Sim" : "Não" }}
            </span>
          </v-col>

          <v-col cols="12">
            <CPTFormSubtitle label="Endereço" />
          </v-col>
          <v-col cols="12 mb-5 ml-4" class="pa-0 d-flex">
            <v-col
              cols="8"
              v-text="
                `${endereco.logradouro}, ${
                  endereco.bairro
                }, ${endereco.numero || 'S/N'} - ${endereco.cidade.nome}/${
                  endereco.cidade.estado.sigla
                }`
              "
              class="pb-0 text-uppercase"
            />
            <v-col
              v-if="endereco.complemento"
              v-text="`Complemento: ${endereco.complemento}`"
              class="pb-0"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <CPTFormSubtitle label="Documentos" />
        </v-col>

        <v-col cols="12">
          <ListaDocumentos v-if="inscricao" :inscricao="inscricao" />
        </v-col>

        <v-col v-if="inscricao.matricula.status !== 'CURSANDO'">
          O STATUS DESTA MATRÍCULA É
          <strong>{{ inscricao.matricula.status }}</strong>
        </v-col>
        <!--STATUS E UNIDADE -->
        <v-form ref="form" class="d-flex justify-center">
          <v-row class="pt-4">
            <v-col cols="12" md="6">
              <CPTSelect
                v-model="inscricao.status"
                label="Status"
                :items="status"
              />
            </v-col>
            <v-col cols="12" md="6">
              <CPTAutocomplete
                v-model="unidadeEnsino"
                :disabled="inscricao.status != 'DEFERIDO'"
                :items="unidadesEnsino"
                :required="inscricao.status == 'DEFERIDO'"
                itemText="nomeCompleto"
                label="Unidade de Destino"
                noDataText="Nenhuma unidade encontrada"
                return-object
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <CPTTextArea
                v-model="inscricao.observacao"
                auto-grow
                label="Observação"
                outlined
                rounded
              />
            </v-col>
          </v-row>
        </v-form>
        <!--STATUS E UNIDADE FIM-->

        <v-col cols="12" class="d-flex justify-end">
          <CPTBtn
            label="Salvar"
            icon="mdi-content-save"
            @click="onSave"
            :loading="loading"
          />
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CPTAutocomplete from "@/components/Autocomplete";
import CPTBtn from "@/components/Btn";
import CPTFormSubtitle from "@/components/FormSubtitle";
import CPTSelect from "@/components/Select";
import CPTTextArea from "@/components/TextArea";
import ListaDocumentos from "./ListaDocumentos.vue";
import { format, parseISO } from "date-fns";

export default {
  name: "dialog-inscricao",

  components: {
    CPTAutocomplete,
    CPTBtn,
    CPTFormSubtitle,
    CPTSelect,
    CPTTextArea,
    ListaDocumentos,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    unidadesEnsino: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    endereco: null,
    loading: false,
    status: [
      { text: "Pendente", value: "PENDENTE" },
      { text: "Deferido", value: "DEFERIDO" },
      { text: "Aguardando Correção", value: "AGUARDANDO_CORRECAO" },
      { text: "Eliminado", value: "ELIMINADO" },
    ],
    unidadeEnsino: null,
  }),

  computed: {
    inscricao: {
      get() {
        return this.value;
      },
      set(inscricao) {
        this.$emit("input", inscricao);
      },
    },
  },

  created() {
    this.endereco = this.inscricao.matricula.pessoa.endereco;
  },

  methods: {
    format,
    parseISO,

    onSave() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$http
          .put(`/plantao-ferias/${this.inscricao.id}`, {
            status: this.inscricao.status,
            unidadeEnsino: this.unidadeEnsino?.id || null,
            observacao: this.inscricao.observacao || "",
          })
          .then((inscricaoUpdated) => {
            this.showMessage("Inscrição atualizada com sucesso", "success");
            this.loading = false;
            let inscricao = {
              ...inscricaoUpdated,
              unidadeDestino: this.unidadesEnsino.find(
                (u) => u.id == inscricaoUpdated.unidade_destino,
              ),
            };
            this.$emit("save", inscricao);
          })
          .catch((error) => {
            this.showMessage(error, "error");
            this.loading = false;
          });
      } else {
        this.showMessage("Verifique os campos obrigatórios!", "error");
      }
    },
  },
};
</script>

<style scoped>
.cvi-dialog-toolbar {
  z-index: 1;
  margin: 0;
  top: 0;
  position: sticky;
  padding: 0;
}
</style>
